import intersection from 'lodash/intersection';
import isFunction from 'lodash/isFunction';
import xor from 'lodash/xor';
import { EventEmitter } from './eventEmitter';

export const urlStoredFilter = ({
  initValue = '',
  dataKey = 'filter',
  activeAttr = 'data-active',
  menuSelector = '[data-url-stored-filter-menu]',
  targetSelector = '[data-url-stored-filter-target]',
  listeners = [],
  isMultiple = false,
}) => {
  const valueAttr = `data-${dataKey}`;

  const EE = new EventEmitter();
  const navItems = document.querySelectorAll(menuSelector) || [];

  navItems.forEach((item) => {
    EE.subscribe(updateActiveAttr(item, activeAttr, valueAttr, true));

    item.addEventListener('click', () => {
      EE.emit(
        updateSearchParam(
          dataKey,
          item.getAttribute(valueAttr) || '',
          isMultiple
        )
      );
    });
  });

  const contentItems = document.querySelectorAll(targetSelector) || [];

  contentItems.forEach((item) => {
    EE.subscribe(updateActiveAttr(item, activeAttr, valueAttr));
  });

  const activeTagsList = getSearchListByKey(dataKey);

  if (activeTagsList.length > 0) {
    const activeValues = isMultiple
      ? activeTagsList.join(',')
      : activeTagsList[0];

    // update items if search params have already been applied
    EE.emit(activeValues);
  } else {
    // set initValue if search params is clear
    EE.emit(updateSearchParam(dataKey, initValue, isMultiple));
  }

  // NOTE: need to keep order for call listeners after DOM updating
  if (listeners.length) {
    listeners.forEach((listener) => {
      if (isFunction(listener)) {
        EE.subscribe(listener);
      }
    });
  }

  window.onpopstate = ({ state }) => {
    if (state) {
      EE.emit(state.searchParams || '');
    }
  };

  return {
    emit: (data, ...rest) =>
      EE.emit(updateSearchParam(dataKey, data, isMultiple), ...rest),
  };
};

function updateActiveAttr(item, activeAttr, valueAttr, isEmptyDefault = false) {
  return (data = '') => {
    const hasTag = Boolean(data);
    const searchTagList = getListFromString(data);
    const containedTagList = getListFromString(item.getAttribute(valueAttr));

    const isDefaultItem = isEmptyDefault
      ? !containedTagList.length && !searchTagList.length
      : true;

    const isActiveItem = hasTag
      ? intersection(searchTagList, containedTagList).length > 0
      : isDefaultItem;

    item.setAttribute(activeAttr, String(isActiveItem));
  };
}

function updateSearchParam(searchKey, value, isMultiple = false) {
  const url = new URL(window.location);

  let newParams = '';

  if (!value) {
    url.searchParams.delete(searchKey);
  } else {
    const activeParams = getListFromString(
      url.searchParams.get(searchKey) || ''
    );

    newParams = isMultiple ? xor(activeParams, [value]).join(',') : value;

    url.searchParams.set(searchKey, newParams);
  }

  window.history.pushState(
    { searchParams: url.searchParams.get(searchKey) || '' },
    document.title,
    url.href
  );

  return newParams || '';
}

function getListFromString(string = '') {
  return String(string).split(',').filter(Boolean) || [];
}

function getSearchListByKey(key) {
  return getListFromString(
    new URL(window.location).searchParams.get(key) || ''
  );
}
